import { HiCurrencyDollar } from "react-icons/hi";
import { TbTransfer } from "react-icons/tb";
import { FaRupeeSign } from "react-icons/fa";
import Step1 from "../assets/Step_1.webp";
import Step2 from "../assets/Step-2.webp";
import Step3 from "../assets/Step_3.webp";

export default function Howitworks(){
    return(
        <div className="mt-[20px] text-[#1A202C] lg:px-[10%]  bg-[#f8fafc]">
        <div className="max-w-6xl mx-auto px-4 py-16 relative">
          <h2 className="text-3xl md:text-4xl text-[#1A202C] font-bold text-center mb-4">How does it work?</h2>
          <p className="text-center text-gray-600 mb-8 text-lg">Get started in 10 minutes with 3 simple steps</p>
          
          <div className="relative flex flex-col md:flex-row items-center justify-between gap-16">
            {/* Progress Line */}
            <div className="hidden md:block absolute left-1/2 top-[55px] transform -translate-x-1/2 h-[2px] bg-gray-300 w-[75%]"></div>
            
            {/* Step 1 */}
            <div className="flex flex-col items-center text-center text-[#1A202C] relative z-10 max-w-xs">
              <div className="relative flex items-center justify-center w-20 h-20 border-4 border-gray-300 rounded-full bg-white">
                <HiCurrencyDollar className="text-[#26a887] text-3xl" />
                <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-10 h-10 bg-[#26a887] text-white flex items-center justify-center text-sm font-bold rounded-full">01</div>
              </div>
              <h3 className="text-xl font-semibold mt-4">Payment Collected</h3>
              <p className="text-gray-600 mt-2">Your Clients or Marketplaces Pay Locally to Your Global Bank Account.</p>
              <img src={Step1} alt="Payment Collected" className="w-full max-w-[300px] h-auto mt-4" loading="lazy"/>
            </div>
            
            {/* Step 2 */}
            <div className="flex flex-col text-[#1A202C] items-center text-center relative md:mt-5 z-20 max-w-xs">
              <div className="relative flex items-center justify-center w-20 h-20 border-4 border-gray-300 rounded-full bg-white">
                <TbTransfer className="text-[#26a887] text-3xl" />
                <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-10 h-10 bg-[#26a887] text-white flex items-center justify-center text-sm font-bold rounded-full">02</div>
              </div>
              <h3 className="text-xl font-semibold mt-4">Payment Transferred</h3>
              <p className="text-gray-600 mt-2">EximPe converts the money to INR and initiates transfer to India.</p>
              <img src={Step2} alt="Payment Transferred" className="w-full max-w-[300px] h-auto mt-4" loading="lazy"/>
            </div>
            
            {/* Step 3 */}
            <div className="flex md:mt-[-18px] text-[#1A202C] flex-col items-center text-center relative z-10 max-w-xs">
              <div className="relative flex items-center justify-center w-20 h-20 border-4 border-gray-300 rounded-full bg-white">
                <FaRupeeSign className="text-[#26a887] text-3xl" />
                <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-10 h-10 bg-[#26a887] text-white flex items-center justify-center text-sm font-bold rounded-full">03</div>
              </div>
              <h3 className="text-xl font-semibold mt-4">Payment Credited</h3>
              <p className="text-gray-600 mt-2">Money credited to Indian Bank account within 24 hours.</p>
              <img src={Step3} alt="Payment Credited" className="w-full max-w-[300px] h-auto mt-4" loading="lazy" />
            </div>
          </div>
        </div>
      </div>
    )
}